import React from 'react';
import 'antd/dist/antd.css';
import {message} from 'antd';
import BaseComponent from "./BaseComponent";
import StorageUtils from "../tools/StorageUtils";

export default class UserComponent extends BaseComponent {

    constructor (props) {
        super(props);
        const CurrentUser = StorageUtils.loadUser();
        if(!CurrentUser || !CurrentUser.token){
            message.warn('未登录！');
            this.props.history.push('/login');
            console.log('CurrentUser is NULL');
        }
        window.CurrentUser = CurrentUser;
    }
}